/**
 * Dev-gated console helpers.
 *
 * Production builds should be quiet — `import.meta.env.DEV` is statically
 * replaced by Vite at build time, so the `console.*` calls are tree-shaken
 * out of the production bundle entirely (no runtime cost, no allocation).
 *
 * Use these in place of bare `console.log` / `console.warn` for any
 * informational logging. Real errors should keep using `console.error`
 * directly so they always surface in production devtools / telemetry.
 */

interface ImportMetaEnvLike {
  env?: { DEV?: boolean };
}

const isDev =
  ((import.meta as unknown as ImportMetaEnvLike).env?.DEV ?? false) === true;

export const devLog: (...args: unknown[]) => void = isDev
  ? (...args) => console.log(...args)
  : () => {};

export const devWarn: (...args: unknown[]) => void = isDev
  ? (...args) => console.warn(...args)
  : () => {};

export const devInfo: (...args: unknown[]) => void = isDev
  ? (...args) => console.info(...args)
  : () => {};

export const devDebug: (...args: unknown[]) => void = isDev
  ? (...args) => console.debug(...args)
  : () => {};
